import { FunctionComponent, PropsWithChildren } from 'react';
import { Box, TColor } from '@bridebook/ui';
import componentStyles from './supplier-update-tag.style';

export interface ISharedProps {
  color?: TColor;
}

interface IProps extends ISharedProps, PropsWithChildren {}

const SupplierUpdateTag: FunctionComponent<IProps> = ({ children, color }) => {
  const styles = componentStyles({ color });

  return (
    <Box style={styles.wrapper} data-name="supplier-update-tag">
      {children}
    </Box>
  );
};

export default SupplierUpdateTag;
